import React, { memo, useContext } from 'react'

import { func, string } from 'prop-types'

import CardFooter from 'Pods/Shared/Waitlist/CardFooter/CardFooter'
import SubscriptionBullets from 'Pods/Shared/Waitlist/SubscriptionBullets/SubscriptionBullets'
import { useSubscriptionHref } from 'Pods/ThreeDStudio/Hooks/useSubscriptionHref'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

import { TODO_LEARN_MORE_HREF } from '../../constants'

function SubscriptionCard({ ctaLabel = '', onClose: handleClose }) {
  const t = useTranslation()
  const { locale } = useContext(ThreeDStudioPageContext)
  const subscriptionPrice = useThreeDStudioStore(state => state.subscription.subscriptionPrice)
  const subscriptionOriginalPrice = useThreeDStudioStore(
    state => state.subscription.subscriptionOriginalPrice
  )
  const subscriptionMonthlyModels = useThreeDStudioStore(
    state => state.subscription.subscriptionMonthlyModels
  )
  const subscriptionHref = useSubscriptionHref()
  const resolvedCtaLabel = ctaLabel || t('usageModal.subscriptionCard.cta')

  return (
    <section className="usage-modal__card usage-modal__card--subscription">
      <div className="usage-modal__card-chip cgt-caption-semibold usage-modal__card-chip--subscription">
        {t('usageModal.tags.subscription')}
      </div>

      {subscriptionPrice && (
        <div className="usage-modal__price">
          {subscriptionOriginalPrice && (
            <span className="usage-modal__price-original cgt-body-lg-semibold">
              {subscriptionOriginalPrice}
            </span>
          )}
          <span className="cgt-heading-300">{subscriptionPrice}</span>
          <span className="usage-modal__price-unit cgt-caption-semibold">
            {t('usageModal.subscriptionCard.priceUnit')}
          </span>
        </div>
      )}

      <SubscriptionBullets
        variant="subscription"
        monthlyModels={subscriptionMonthlyModels}
        locale={locale}
        showAdvancedFeaturesBullet
      />

      <CardFooter
        variant="subscription"
        ctaLabel={resolvedCtaLabel}
        subscriptionHref={subscriptionHref}
        learnMoreHref={TODO_LEARN_MORE_HREF}
        onClose={handleClose}
      />
    </section>
  )
}

SubscriptionCard.propTypes = {
  ctaLabel: string,
  onClose: func.isRequired,
}

export default memo(SubscriptionCard)
